import AuthCMS from "../../Layouts/AuthCMS"

import ChromeIcon from "../../Layouts/AuthCMS/Icon/ChromeIcon"
import AndroidIcon from "../../Layouts/AuthCMS/Icon/AndroidIcon"

const AppList = () => {
    return (
        <AuthCMS tabActive={"/app"}>
           <div className="flex flex-wrap p-4">
                <h1 className="text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight text-center w-full">Ứng dụng</h1>
                <div className="flex flex-wrap flex-1 mt-8 center space-x-0">
                    <div className="w-full lg:w-1/2 mt-4">
                        <div className="flex border rounded-md border-slate-200 shadow-md mx-2 py-4">
                            <div className="px-4 border-r justify-items-center content-center">
                                <ChromeIcon classCustom={"w-28"}/>
                            </div>
                            <div className="w-2/3 ml-2 min-h-48">
                                <h2>Extension for Chrome</h2>
                                <span className=" bg-slate-300 px-2 rounded-md">1.0.0</span>
                                <span className=" bg-slate-300 px-2 rounded-md ml-2">CHROME_EXTENSION</span>
                                <p className="my-4">Công cụ giúp bạn thay đổi IP trên chính trình duyệt, chỉ cần nhập key của  {process.env.REACT_APP_PROJECT_NAME} để sử dụng.</p>
                                <a href="https://chromewebstore.google.com/detail/basicproxy/ciiponbkhklagjlbnajhohfindjhbljn?authuser=1&hl=en" target="_blank" rel="noreferrer" className="bg-slate-200 px-2 py-1 rounded-md text-blue-500">
                                    Tải Xuống
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="w-full lg:w-1/2 mt-4 min-h-64">
                        <div className="flex border rounded-md border-slate-200 shadow-md mx-2 py-4">
                            <div className="px-4 border-r justify-items-center content-center">
                                <AndroidIcon classCustom={"w-28"}/>
                            </div>
                            <div className="w-2/3 ml-2 min-h-48">
                                <h2>ProxyCenter for Android</h2>
                                <span className=" bg-slate-300 px-2 rounded-md">1.0.0</span>
                                <span className=" bg-slate-300 px-2 rounded-md ml-2">Android</span>
                                <p className="my-4">Ứng dụng hỗ trợ tạo kết nối mở trên điện thoại Android</p>
                                <a href="https://app.basicproxy.net/apk/app.basicproxy.net.apk" target="_blank" rel="noreferrer" className="bg-slate-200 px-2 py-1 rounded-md text-blue-500">
                                    Tải xuống
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
        </AuthCMS>
    )
}

export default AppList